import axios from 'axios';
import store from '../redux/store/store';
const API_QUESTION_URL = import.meta.env.VITE_API_URL;
const API_OUTWARD_URL = import.meta.env.VITE_OUTWARD_URL;
const QuestionService = {

    fetchQuestions: async (userId,filter,page) => {
        const userToken = store.getState()?.auth?.user?.accessToken?.token;
        try {
            const response =await axios.get(`/OrderQuestion`, {
                headers: {
                    Authorization: `Bearer ${userToken}`
                },
                params: {  
                    UserId: userId,
                    WithPleaces:true,
                    ecommercePlaceId:filter.ecommercePlaceId,
                    marketPlaceId:filter.marketPlaceId,
                    page:page
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching question:', error);
            throw error;
        }

    },


    answerQuestion: async (requestBody,marketPlaceName) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/MarketPlace/${marketPlaceName}/AnswerQuestion`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },

};
export default QuestionService;